import React from 'react';
import PropTypes from 'prop-types';
import { Play24, Pause24 } from '@carbon/icons-react';
import classNames from 'classnames';

class ComponentVideoDossier extends React.Component {

  state = {
    videoPlaying: false
  };

  videoSection = React.createRef();

  playPauseVideo = () => {
    const video = this.videoSection.current.querySelectorAll('video')[0];

    if (video.paused) {
      // Play the video
      video.play();

      // Update the button text to 'Pause'
      this.setState({ videoPlaying: true });
    } else {
      // Pause the video
      video.pause();

      // Update the button text to 'Play'
      this.setState({ videoPlaying: false });
    }
  };

  render() {
    return (
      <section
        className={classNames({
          'video-playing': this.state.videoPlaying
        })}
        ref={this.videoSection}
      >
        <div className="row">
          <div className="col-lg-12">
            <div className="full-width local-video">
              {Boolean(this.props.content.fieldVideo) &&
              <>
                <video
                  src={this.props.content.fieldVideo.entity.fieldMediaVideoFile.entity.url}
                  controls={true}
                />
              </>
              }
            </div>
          </div>
        </div>

      </section>
    );
  }
}

ComponentVideoDossier.propTypes = {
  content: PropTypes.object.isRequired,
};

export default ComponentVideoDossier;
